export default {"src":"/_next/static/media/lightModeNew.fd544669.svg","height":28,"width":28};